export const enum LanguageCodes {
  English = 'en-us',
  Danish = 'da-DK',
  Swedish = 'sv-SE',
  Finnish = 'fi-FI',
  Dutch = 'nl-NL',
  Norwegian = 'nb-NO',
  French = 'fr-FR',
  German = 'de-DE',
  Spanish = 'es-ES',
}